export enum EHealthProceduresTypes {
  IMAGING_TEST = 'exameImagem',
  SURGERY = 'cirurgia',
  LABORATORY_TEST = 'exameLaboratorial',
  ANATOMOPATHOLOGICAL_TEST = 'exameAnatomopatologico',
  VACCINE = 'vacina',
  MEDICAL_APPOINTMENT = 'consultaMedica',
  MEDICAL_NOTE = 'notaMedica',
  RADIOLOGY_IMAGING_TEST = 'exameImagemRadiologia',
  MATERNAL_INFANT_IMAGING_TEST = 'exameImagemMaternoInfantil',
  ADMISSION = 'internacao',
  BIRTH = 'informacoesNascimento',
  ECHOCARDIOGRAM_TEST = 'exameEcocardiograma',
  DIAGNOSIS = 'diagnostico',
  EVALUATION_BREAST_IMAGING_TEST = 'exameImagemMamaAvaliacao',
  DIAGNOSIS_BIOPSY = 'biopsiaDiagnostico',
  DIAGNOSIS_ANATOMOPATHOLOGICAL_TEST = 'exameAnatomopatologicoDiagnostico'
}

export enum EHealthProceduresConducts {
  SURGERY = 'cirurgia',
  MEDICAL_APPOINTMENT = 'consultaMedica',
  MEDICAL_NOTE = 'notaMedica',
  BIRTH = 'informacoesNascimento'
}

export enum EHealthProceduresOmics {
  IMAGING_TEST = 'exameImagem',
  LABORATORY_TEST = 'exameLaboratorial',
  ANATOMOPATHOLOGICAL_TEST = 'exameAnatomopatologico',
  VACCINE = 'vacina',
  RADIOLOGY_IMAGING_TEST = 'exameImagemRadiologia',
  MATERNAL_INFANT_IMAGING_TEST = 'exameImagemMaternoInfantil',
  ECHOCARDIOGRAM_TEST = 'exameEcocardiograma',
  DIAGNOSIS_BIOPSY = 'biopsiaDiagnostico',
  DIAGNOSIS_ANATOMOPATHOLOGICAL_TEST = 'exameAnatomopatologicoDiagnostico',
  EVALUATION_BREAST_IMAGING_TEST = 'exameImagemMamaAvaliacao'
}

export type HealthProceduresTypes = `${EHealthProceduresTypes}`
export type HealthProceduresTypesOmics = `${EHealthProceduresOmics}`
export type HealthProceduresTypesConduct = `${EHealthProceduresConducts}`

export enum EHealthProceduresSubtypes {
  NEURO = 1,
  HEAD_AND_NECK = 2,
  ABDOMEN = 3,
  CHEST = 4,
  SKELETAL_MUSCLE = 5
}

interface IHealthProceduresModel {
  id: string
  startDate: string
  endDate: string
  isAltered: boolean
  passage: string
  description: string
  subtypes: number[]
}

export interface IHealthProcedures extends IHealthProceduresModel {
  type: HealthProceduresTypes | string
  biradsCategory?: number
}

export interface IHealthProceduresOmics extends IHealthProceduresModel {
  type: HealthProceduresTypesOmics
}

export interface IHealthProceduresConduct extends IHealthProceduresModel {
  type: HealthProceduresTypesConduct
}
